import {useEffect, useState} from "react";
import {findGripsWithPagination} from "../api/figureApiClient";

export const useGrips = (page, pageSize, reloadTrigger) => {
    const [grips, setGrips] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const gripsWithPagination = findGripsWithPagination(page, pageSize, abortController.signal);

        gripsWithPagination
            .then(
                (data) => {
                    const grips = data.grips;
                    const pagination = data.pagination;

                    setGrips(grips)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {grips : grips, pagination};
};